<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="vuesax/linear/setting-2">
    <g id="setting-2">
      <path
        id="Vector"
        d="M7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10Z"
        stroke="#212529"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_2"
        d="M9.26664 1.66699L10.7333 1.66699C11.6 1.66699 12.3166 2.37533 12.3166 3.25033C12.3166 4.75866 13.3833 5.37533 14.6916 4.61699C15.4416 4.18366 16.4166 4.44199 16.85 5.20033L17.675 6.64199C18.0666 7.30033 17.8333 8.15033 17.175 8.54199L17.0166 8.63366C15.7083 9.38366 15.7083 10.617 17.0166 11.3753L17.175 11.467C17.8333 11.8587 18.0666 12.7087 17.675 13.367L16.85 14.8087C16.4166 15.567 15.4416 15.8253 14.6916 15.392C13.3833 14.6337 12.3166 15.2503 12.3166 16.7587C12.3166 17.6253 11.6083 18.342 10.7333 18.342L9.26664 18.342C8.39997 18.342 7.6833 17.6337 7.6833 16.7587C7.6833 15.2503 6.61664 14.6337 5.3083 15.392C4.54997 15.8253 3.5833 15.567 3.14997 14.8087L2.32497 13.367C1.9333 12.7087 2.16664 11.8587 2.82497 11.467L2.9833 11.3753C4.29164 10.6253 4.29164 9.39199 2.9833 8.63366L2.82497 8.54199C2.16664 8.15033 1.9333 7.30032 2.32497 6.64199L3.14997 5.20032C3.5833 4.44199 4.55831 4.18366 5.30831 4.61699C6.61664 5.37533 7.6833 4.75866 7.6833 3.25033C7.6833 2.37533 8.39997 1.66699 9.26664 1.66699Z"
        stroke="#212529"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </g>
</svg>
